__turbopack_context__.v({
  "aaasHeading": "ZpBcTa_aaasHeading",
  "aaasSection": "ZpBcTa_aaasSection",
  "aaasSummary": "ZpBcTa_aaasSummary",
  "billingItem": "ZpBcTa_billingItem",
  "billingLabel": "ZpBcTa_billingLabel",
  "billingList": "ZpBcTa_billingList",
  "billingRow": "ZpBcTa_billingRow",
  "billingTitle": "ZpBcTa_billingTitle",
  "billingValue": "ZpBcTa_billingValue",
  "billingValueText": "ZpBcTa_billingValueText",
  "calculatorSection": "ZpBcTa_calculatorSection",
  "comparisonColumn": "ZpBcTa_comparisonColumn",
  "comparisonGrid": "ZpBcTa_comparisonGrid",
  "comparisonIcon": "ZpBcTa_comparisonIcon",
  "comparisonIconThem": "ZpBcTa_comparisonIconThem",
  "comparisonIconUs": "ZpBcTa_comparisonIconUs",
  "comparisonItem": "ZpBcTa_comparisonItem",
  "comparisonList": "ZpBcTa_comparisonList",
  "comparisonTextThem": "ZpBcTa_comparisonTextThem",
  "comparisonTextUs": "ZpBcTa_comparisonTextUs",
  "comparisonTitle": "ZpBcTa_comparisonTitle",
  "container": "ZpBcTa_container",
  "copyControl": "ZpBcTa_copyControl",
  "ctaRow": "ZpBcTa_ctaRow",
  "deliverables": "ZpBcTa_deliverables",
  "deliverablesTitle": "ZpBcTa_deliverablesTitle",
  "heroBleed": "ZpBcTa_heroBleed",
  "heroBleedContent": "ZpBcTa_heroBleedContent",
  "heroBleedContentPassThrough": "ZpBcTa_heroBleedContentPassThrough",
  "heroBleedOverlay": "ZpBcTa_heroBleedOverlay",
  "heroSubtitle": "ZpBcTa_heroSubtitle",
  "heroTitle": "ZpBcTa_heroTitle",
  "newBadge": "ZpBcTa_newBadge" + " " + __turbopack_context__.i(262643)["brandchip"],
  "packageCard": "ZpBcTa_packageCard",
  "packageCta": "ZpBcTa_packageCta",
  "packageDescription": "ZpBcTa_packageDescription",
  "packageDuration": "ZpBcTa_packageDuration",
  "packageHeader": "ZpBcTa_packageHeader",
  "packageList": "ZpBcTa_packageList",
  "packagePrice": "ZpBcTa_packagePrice",
  "packagesAvailability": "ZpBcTa_packagesAvailability",
  "packagesHeading": "ZpBcTa_packagesHeading",
  "packagesSection": "ZpBcTa_packagesSection",
  "page": "ZpBcTa_page",
  "procurement": "ZpBcTa_procurement",
  "testimonial": "ZpBcTa_testimonial",
  "testimonialContainer": "ZpBcTa_testimonialContainer",
  "testimonialInner": "ZpBcTa_testimonialInner",
  "testimonialQuote": "ZpBcTa_testimonialQuote",
  "trustRow": "ZpBcTa_trustRow",
  "trustRowText": "ZpBcTa_trustRowText",
  "value": "ZpBcTa_value",
});
